"use client";

import React, { useEffect, useState } from "react";
import { ArrowRight, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UnleashYourAcademicVoice() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [offsetY, setOffsetY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setOffsetY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="224165" id="redefining-global-mobility" className="relative bg-gradient-to-b from-white to-[#F7F7F7] overflow-hidden min-h-[85vh] flex items-center py-24 lg:py-32">
      {}
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.03] pointer-events-none select-none overflow-hidden" aria-hidden="true">
        <span className="font-serif text-[40rem] leading-none text-primary translate-y-12">
          M
        </span>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-12 gap-16 lg:gap-20 items-center">
          
          {}
          <div ref={contentRef} className="lg:col-span-7 flex flex-col justify-center max-w-3xl">
            <h1 className={`font-serif text-5xl md:text-6xl lg:text-8xl font-bold tracking-widest text-foreground leading-[1.1] mb-6 transition-all duration-1000 ease-out ${isContentVisible ? "animate-text-reveal opacity-100 translate-y-0 tracking-[0.15em]" : "opacity-0 translate-y-8 tracking-widest"}`} style={{
            transitionDelay: "400ms",
            animationDuration: "1.2s"
          }}>
              Global Mobility, Refined.
            </h1>
            
            <p className={`font-default text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl leading-relaxed transition-all duration-700 ease-out animate-slide-up ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: "200ms"
          }}>
              From our heritage in Dover, Delaware, Moveonix delivers a concierge-level transportation experience. Whether you are booking a premium ride or joining our elite fleet, we redefine the standards of global movement.
            </p>
            
            <div className={`flex flex-col sm:flex-row gap-4 transition-all duration-700 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: "600ms"
          }}>
              <Button asChild size="lg" className="group relative overflow-hidden h-12 px-8 text-base bg-primary hover:bg-[#C9A15A] hover:scale-108 hover:shadow-[0_0_25px_rgba(201,161,90,0.5)] text-primary-foreground rounded-md shadow-md transition-all duration-300">
                <Link to="/HomePage" className="inline-flex items-center">
                  <span className="relative z-10 flex items-center">
                    Book a Ride
                    <ArrowRight className="ml-2 size-5" />
                  </span>
                  <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shine_1.5s_infinite] transition-transform" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="group relative overflow-hidden h-12 px-8 text-base bg-transparent border-primary text-primary hover:bg-accent hover:border-[#C9A15A] hover:text-[#C9A15A] hover:scale-108 hover:shadow-[0_0_25px_rgba(201,161,90,0.3)] rounded-md shadow-md transition-all duration-300">
                <Link to="/HomePage" className="inline-flex items-center">
                  <span className="relative z-10 flex items-center">
                    <BookOpen className="mr-2 size-5" />
                    Become a Driver
                  </span>
                  <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-primary/10 to-transparent -translate-x-full group-hover:animate-[shine_1.5s_infinite] transition-transform" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-5 relative transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="group relative w-full aspect-[3/4] rounded-md overflow-hidden border border-border shadow-xl bg-muted hover:outline hover:outline-2 hover:outline-primary transition-all duration-300">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658108/img/premium_vehicle_interior_luxury.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658108/img/premium_vehicle_interior_luxury.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658108/img/premium_vehicle_interior_luxury.png-wvc-sizes" alt="Premium vehicle interior with leather detailing" loading="lazy" className="absolute inset-0 w-full h-[120%] object-cover object-center animate-zoom-in brightness-110 contrast-105" style={{
              transform: `translateY(-${offsetY * 0.08}px)`,
              transition: 'transform 0.1s ease-out'
            }} />
              {}
              <div className="absolute inset-0 ring-1 ring-inset ring-primary/10 rounded-md pointer-events-none"></div>
            </div>
            
            {}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-primary/10 rounded-md blur-2xl -z-10"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-primary/5 rounded-md blur-3xl -z-10"></div>
          </div>

        </div>
      </div>
    </section>;
}